import { Pipe, PipeTransform } from '@angular/core';
import { ObjectMap, Utilities, } from '@socrates/common';

@Pipe({
	name: 'propTest',
	standalone: false,
})
export class PropTestPipe implements PipeTransform {

	private objectMap: ObjectMap = new ObjectMap();

	transform(list: any, args): any {

		let result: any = list;

		if (Array.isArray(list) && list.length > 0) {
			if (args.propValue && args.propName) {

				if (typeof args.propValue !== 'string' || args.propValue.length > 0) {
					result = list.filter(
						(val: any) => {
							const testVal: any = this.objectMap.getValue(val, args.propName);
							if (Array.isArray(testVal)) {
								let matches = true;
								for (let li = 0; matches && li < testVal.length; li++) {
									const value: any = testVal[li];
									if (args.reverse) {
										matches = value !== args.propValue;
									} else {
										matches = value === args.propValue;
									}
								}
								return matches;
							} else {
								if (Array.isArray(args.propValue)) {
									const findings = args.propValue.find(
										(val: any) => {
											return val == testVal;
										}
									);
									return Utilities.hasValidValue(findings);
								} else {
									if (args.reverse) {
										return testVal !== args.propValue;
									} else {
										return testVal === args.propValue;
									}
								}
							}
						}
					);
				}
			} else if (Array.isArray(args.propList) && args.propList?.length > 0) {
				result = list.filter(
					(element: any) => {
						let matches = true;

						for (let li = 0; matches && li < args.propList.length; li++) {
							const { propName, propValue } = args.propList[li];

							const testVal: any = this.objectMap.getValue(element, propName);
							if (Array.isArray(testVal)) {
								matches = false; // if testVal.length == 0
								// eslint-disable-next-line @typescript-eslint/prefer-for-of
								for (let li = 0; li < testVal.length; li++) {
									const value: any = testVal[li];
									if (args.reverse) {
										matches = value !== propValue;
									} else {
										matches = value === propValue;
									}
									if (!matches) {
										break;
									}
								}

							} else {
								if (args.reverse) {
									matches = testVal !== propValue;
								} else {
									matches = testVal === propValue;
								}
							}
						}
						return matches;
					}
				);
			}
		}
		return result;
	}
}
